import React, { useState } from 'react'
import { Modal, Form, Button, Spinner } from 'react-bootstrap'
import { showToast, TOAST_FAILURE } from '../../../utils/toast/Toast'

// Manual-paste "Code using AI" modal. Splits pasted text into raw sample lines and
// asks the parent to generate a parser (parent owns the API call + applying the code).
const AIParserModal = ({ show, onHide, onGenerate, generating, brandName }) => {
    const [sampleText, setSampleText] = useState('')

    const handleGenerate = async () => {
        const samples = sampleText
            .split('\n')
            .map(l => l.replace(/\r$/, ''))
            .filter(l => l.trim().length > 0)
            .slice(0, 60)
        if (samples.length === 0) {
            showToast('Paste at least one sample line', TOAST_FAILURE)
            return
        }
        const ok = await onGenerate(samples)
        if (ok) {
            setSampleText('')
            onHide()
        }
    }

    return (
        <Modal show={show} onHide={() => !generating && onHide()} centered>
            <Modal.Header closeButton className="py-3 px-4">
                <Modal.Title className="fs-6 d-flex align-items-center">
                    <i className="bi bi-magic me-2 text-info"></i>
                    Generate Parser with AI
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4">
                <p className="small text-muted mb-2">
                    Paste a few raw lines exactly as they come from the weighbridge (one per line).
                    AI will write a <code>parse(data)</code> function and load it into the editor.
                </p>
                <Form.Control
                    as="textarea"
                    rows={8}
                    value={sampleText}
                    onChange={(e) => setSampleText(e.target.value)}
                    placeholder={'000070\n000070\nGS, 12345, kg\n...'}
                    spellCheck={false}
                    style={{
                        fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                        fontSize: '13px',
                        backgroundColor: '#1e1e1e',
                        color: '#d4d4d4',
                        border: '1px solid #333',
                    }}
                />
                <Form.Text className="text-muted small">
                    Tip: the brand name ({brandName || 'not set'}) is sent as a hint. Up to 60 lines used.
                </Form.Text>
            </Modal.Body>
            <Modal.Footer className="py-2 px-4">
                <Button variant="light" size="sm" onClick={onHide} disabled={generating}>
                    Cancel
                </Button>
                <Button variant="info" size="sm" onClick={handleGenerate} disabled={generating || !sampleText.trim()}>
                    {generating ? (
                        <><Spinner size="sm" animation="border" className="me-1" />Generating...</>
                    ) : (
                        <><i className="bi bi-magic me-1"></i>Generate Parser</>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AIParserModal
